module.exports = __webpack_public_path__ + "static/media/oneb.fb764cfe.svg";